import { NOT_FOUND } from 'redux-first-router';
import {
    // ROUTE_HOME,
    ROUTE_LOGIN,
    ROUTE_ORDER
} from './state/modules/routing';
// import { loadHomePage } from './state/modules/home/saga';
import { loadOrderPage } from './state/modules/order/saga';


const routesMap = {
  [NOT_FOUND]: {
    path: '/not-found',
    component: 'NotFound',
  },
  [ROUTE_LOGIN]: {
    path: '/login',
    component: 'Login',
    requiresAuth: false
  },
  // [ROUTE_HOME]: {
  //   path: '/home',
  //   component: 'Home',
  //   saga: loadHomePage,
  //   requiresAuth: false
  // },
  [ROUTE_ORDER]: {
    path: '/',
    component: 'Order',
    saga: loadOrderPage,
    requiresAuth: false
  }
};

export default routesMap;